import React from 'react';
import { Image } from 'semantic-ui-react';

const divStyle = { textAlign: 'left' };
const imgStyle = { height: '1.4em', width: '1.4em' };

const TickerCell = props => {
  // console.log('THESE Props: ', props);
  const { cellData, isScrolling } = props;

  if (!cellData) {
    return <div />;
  }
  const { value } = cellData;
  const { ticker, logoUrl } = value;

  let url = isScrolling
    ? 'https://react.semantic-ui.com/assets/images/wireframe/square-image.png'
    : logoUrl;
  // const url =
  //   'https://react.semantic-ui.com/assets/images/wireframe/square-image.png';
  return (
    <div style={divStyle}>
      <Image
        alt=""
        style={imgStyle}
        src={url}
        // src="https://bittrexblobstorage.blob.core.windows.net/public/efc27a0f-e2cb-47a6-819c-18b96d8868b1.png"
        avatar
      />
      {ticker}
    </div>
  );
};

export default TickerCell;



// WEBPACK FOOTER //
// ./src/containers/Markets/components/MarketsTable/components/MarketsTableComponent/components/TickerCell/index.jsx